export default "__VITE_ASSET__35d8a83e__"